import React from "react";
import { Route, Routes } from "react-router-dom";

import ProtectedMainRoute from "./container/Login/ProtectedMainRoute";
import LoginPage from "./container/Login/LoginPage";

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="*" element={<ProtectedMainRoute />} />
    </Routes>
  );
};

export default App;
